// Typed expression model for the document expressions layer.
//
// These types are defined within this library and intentionally NOT re-exported
// from any `@msys/*` package, so the layer's contract is explicit and
// self-contained.
/** The single present-null sentinel (see {@link ExplicitNull}). */
export const EXPLICIT_NULL = { kind: "explicit_null" };
/** The single no-value sentinel (see {@link MissingPropertyValue}). */
export const MISSING_PROPERTY_VALUE = { kind: "missing" };
//# sourceMappingURL=types.js.map